import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=40d41d5f&scoped=true&"
import script from "./Collaborators.vue?vue&type=script&lang=js&"
export * from "./Collaborators.vue?vue&type=script&lang=js&"
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=40d41d5f&scoped=true&lang=css&"
import style1 from "./Collaborators.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d41d5f",
  null
  
)

export default component.exports